/**
 * Application Entry Point
 * =======================
 * Main entry file for the React application.
 */

import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// Create root and render app
const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Web Vitals reporting (optional - uncomment to enable)
// import reportWebVitals from './reportWebVitals';
// reportWebVitals(console.log);
